import { render, staticRenderFns } from "./enrolledTable.vue?vue&type=template&id=17206029&scoped=true"
import script from "./enrolledTable.vue?vue&type=script&lang=js"
export * from "./enrolledTable.vue?vue&type=script&lang=js"
import style0 from "./enrolledTable.vue?vue&type=style&index=0&id=17206029&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17206029",
  null
  
)

export default component.exports